// $.user по требованиям для СОПР 1.0 https://cianru.atlassian.net/wiki/spaces/ML/pages/443613219
import { IApplicationState } from '../../../types/redux';
import { TUser } from '../../../types/analytics';
import { isAuthenticatedUser } from '../../user';

export function createUserTrackingData(state: IApplicationState): TUser {
  const { userData } = state;

  if (!isAuthenticatedUser(userData)) {
    return { type: 'not_authorized' };
  }

  return {
    cianUserId: userData.id,
    email: userData.email,
    type: userData.userType,
    userId: userData.userId,
  };
}
